export default function sumValuesNoKey(arr) {
  return Object.values(arr).reduce((a, b) => a + b);
}
